/**
 * Formats a US postal code, hyphenating ZIP+4 codes (#####-####).
 *
 * 5-digit ZIP codes are returned unchanged. Malformed, short, or empty
 * values are returned as-is so callers can degrade gracefully.
 *
 * @param postalCode raw postal code string, e.g. "800142736" or "80014"
 * @returns formatted postal code, e.g. "80014-2736" or "80014"
 */
export function formatZipCode(postalCode: string | null | undefined): string {
  if (!postalCode) {
    return '';
  }

  const digitsOnly = postalCode.replace(/[\s-]/g, '');

  if (!/^\d+$/.test(digitsOnly)) {
    return postalCode;
  }

  if (digitsOnly.length === 9) {
    return `${digitsOnly.slice(0, 5)}-${digitsOnly.slice(5)}`;
  }

  return postalCode;
}
